import Account from "@/helper/AccountHelper.js";
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';
import ConfigManager from '@/config/ConfigManager.js';
import { 
    FinHealthSurveyResultModel, 
    FinHealthSubmitResponseModel 
} from '../model/FinancialHealthModel.js';

/**
 * Financial Health Survey API Service
 * @method apiCheckSurvey - Check if user has already submitted survey
 * @method apiGetSurveyAnswer - Get user's survey answers and scores
 * @method apiSubmitSurvey - Submit survey answers
 */
export default {
    /**
     * Check if user has already submitted the survey
     * @returns Observable - resolves if not submitted, rejects with code "1904" if already submitted
     */
    apiCheckSurvey: function () {
        const token = Account.getToken();
        const url = ConfigManager.getApiModuleUrl() + "/survey/check";
        
        return BzbsApi.connectBzbsPost(url, token, {})
            .pipe(map((res) => {
                return res.data;
            }));
    },

    /**
     * Get user's survey answers and scores
     * @returns Observable<FinHealthSurveyResultModel>
     */
    apiGetSurveyAnswer: function () {
        const token = Account.getToken();
        const url = ConfigManager.getApiModuleUrl() + "/survey/answer";
        
        return BzbsApi.connectBzbsGet(url, token, {})
            .pipe(map((res) => {
                if (res.data && res.data.data) {
                    return new FinHealthSurveyResultModel(res.data.data);
                }
                return null;
            }));
    },

    /**
     * Submit survey answers
     * @param {Array} answers - Array of { Category, QuestionNumber, Answer }
     * @param {number} timeSpentSeconds - Time spent on survey in seconds
     * @param {boolean} completed - Whether the survey is completed (default: true for backward compatibility)
     * @returns Observable<FinHealthSubmitResponseModel>
     */
    apiSubmitSurvey: function (answers, timeSpentSeconds, completed = true) {
        const token = Account.getToken();
        const url = ConfigManager.getApiModuleUrl() + "/survey/fin_health";
        
        const data = {
            Completed: completed,
            Answers: answers,
            TimeSpentSeconds: timeSpentSeconds
        };
        
        return BzbsApi.connectBzbsPostJson(url, token, data)
            .pipe(map((res) => {
                if (res.data && res.data.data) {
                    return new FinHealthSubmitResponseModel(res.data.data);
                }
                return res.data;
            }));
    }
};
